import server from "../../../Server/index";
import template from "./gameConfiguration.html";
import copyDeleteTemplate from "./copyDelete.html";
import repeatController from "../../../../../ui-formly/types/repeater/controller";

import selectAsyncUtils from "../../../../../ui-formly/types/selectAsync/utils";
import fieldHelpers from "../../../../../ui-formly/fieldHelpers";
import { CopyDeleteController } from "./copyDeleteController";

function formlyGameConfigurations(authService) {
  var formly = {
    key: "GameConfigurations",
    name: "GameConfigurations",
    controller: repeatController,
    templateUrl: template,
    templateOptions: {
      addText: "Add Configuration",
      fields: [
        ...fieldHelpers.columnLayout(
          [
            {
              key: "ThemeId",
              name: "ThemeId",
              type: "selectAsync",
              templateOptions: {
                required: true,
                label: "Theme",
                query: selectAsyncUtils.getQuery(server, "themeQuery"),
                saveNewItem: selectAsyncUtils.getSave(server, "themeSave"),
                showAddButton: authService.hasPermission("machineEdit"),
                getDefaultItem: function (model) {
                  return {
                    Id: model.ThemeId,
                    Name: model.ThemeName,
                  };
                },
                updateNameProp: "ThemeName",
              },
            },
            {
              key: "DenominationId",
              name: "DenominationId",
              type: "selectAsync",
              templateOptions: {
                required: true,
                label: "Denomination",
                query: selectAsyncUtils.getQuery(server, "denominationQuery"),
                saveNewItem: selectAsyncUtils.getSave(
                  server,
                  "denominationSave"
                ),
                showAddButton: authService.hasPermission("machineEdit"),
                getDefaultItem: function (model) {
                  return {
                    Id: model.DenominationId,
                    Name: model.DenominationName,
                  };
                },
                updateNameProp: "DenominationName",
              },
            },
          ],
          2
        ),
        ...fieldHelpers.columnLayout(
          [
            fieldHelpers.simplePercentageField({
              key: "Par",
              label: "Par",
              min: 0,
              max: 100,
              step: 0.001,
            }),
            fieldHelpers.simpleStringField({
              key: "Payline",
              label: "Payline",
            }),
            fieldHelpers.simpleCurrencyField({
              key: "MaxBet",
              label: "Max Bet",
              min: 0,
            }),
            {
              key: "copyDelete",
              name: "copyDelete",
              templateOptions: {
                label: "ㅤ",
              },
              templateUrl: copyDeleteTemplate,
              wrapper: ["bootstrapLabel"],
              controller: CopyDeleteController,
            },
          ],
          4
        ),
      ],
    },
  };

  return [formly];
}

export default formlyGameConfigurations;
